<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IyD92/tc-custom/9781612545653.jpg?1690569365844" alt="This image is the cover for the book You Forgot to Mention"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Forgot to Mention
      </h1>
      <p class="bookDescription body article font2">
        <b>Prepare for the unexpected! This book is a fun and essential tool for new and expecting parents who need tips and tricks on all things baby. </b><br/><br/>Covering every aspect of pregnancy and newborns, <i>You Forgot to Mention</i> gives advice on topics family and friends may “forget to mention” to expecting parents. From projectile vomiting to uterine massages to nipple creams, readers can count on this book to live up to its title. Advice on baby clothing, stimulating labor, and C-sections will have readers taking notes, and laughing as they do, as they prepare for their new baby to come home.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tiffany Parker
      </h2>
      
      <p class="authorDescription body article">Tiffany Parker is a mother of seven kids ranging from teenagers to toddlers. Tiffany has nearly a decade of experience as a first responder and emergency manager and has earned a dual master's degree in Emergency Management and Homeland Security, as well as a bachelor's degree in Public Administration and Emergency Management. Her role as a mother and bonus parent has taught her valuable experiences that she now uses to help other parents going through the same scenarios. Tiffany's degrees, decade of experience as a first responder and her role as a parent allow her the opportunity to pave a path for future generations by sharing her experience through humor and candidness. Tiffany currently focuses her efforts on motivational speaking, writing and education.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d100b79